<template>
	<div>
		<el-row :gutter="12" class="payment-members">
			<el-col :span="8" v-for="(member, key) in members" :key="key" class="payment-members-item">
				<div @dblclick="editHandler(key)">
					<el-card shadow="hover">
						<div class="payment-members-item__header"><strong>{{ member.last_name}} {{ member.first_name}} {{ member.middle_name}}</strong>
						</div>
						<div class="payment-members-itenm__body">
							<ul>
								<li><el-tag type="success" class="icon"><i class="fa fa-at"></i></el-tag> {{ member.email }}</li>
								<li><el-tag type="success" class="icon"><i class="fa fa-phone"></i></el-tag> {{ member.phone }}</li>
							</ul>
						</div>
					</el-card>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="Данные участника" :visible.sync="dialogShow" @close="dialogClose('form')">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right" class="demo-ruleForm">
				<el-input type="hidden" v-model="form.id"></el-input>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="Фамилия" prop="lastName">
								<el-input v-model="form.lastName"></el-input>
						</el-form-item>

						<el-form-item label="Имя" prop="firstName">
								<el-input v-model="form.firstName"></el-input>
						</el-form-item>

						<el-form-item label="Отчество" prop="middleName">
								<el-input v-model="form.middleName"></el-input>
						</el-form-item>

					</el-col>

					<el-col :span="12">
						<el-form-item label="Телефон" prop="phone">
							<div class="el-input">
								<masked-input class="el-input__inner" v-model="form.phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (495) 123-45-67" />
							</div>
						</el-form-item>
						<el-form-item label="E-mail адрес" prop="email">
								<el-input v-model="form.email"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="form.id > 0" @click="deleteHandler('form')" type="danger" style="float:left">Удалить</el-button>
				<el-button @click="dialogClose('form')">Отмена</el-button>
				<el-button type="primary" @click="formSubmit('form')">Сохранить</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import MaskedInput from 'vue-masked-input'
import apiMember from '@/api/modules/payment/member'
export default {
	components: {
		MaskedInput
	},
	data: function () {
		return {
			dialogShow: false,
			members: [],
			form: {
				key: '',
				id: '',
				firstName: '',
				lastName: '',
				middleName: '',
				email: '',
				phone: ''
			},
			rules: {
				firstName: [
					{ required: true, message: 'Укажите имя участника.', trigger: 'blur' }
				],
				lastName: [
					{ required: true, message: 'Укажите фамилию участника.', trigger: 'blur' }
				],
				middleName: [
					{ required: true, message: 'Укажите отчество участника.', trigger: 'blur' }
				],
				email: [
					{ type: 'email', message: 'Укажите корректный адрес электронной почты.', trigger: 'blur' }
				],
				menegerId: [
					{ required: true, message: 'Укажите менеджера.', trigger: 'blur' }
				],
				b24Id: [
					{ required: true, message: 'Укажите Битрикс ID.', trigger: 'blur' }
				],
				companyId: [
					{ required: true, message: 'Выберите компанию.', trigger: 'blur' }
				]
			}
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.buildMemberList()
	},
	methods: {
		buildMemberList () {
			apiMember.findAll({payment_id: this.id}).then((result) => {
				this.members = result
			})
		},
		editHandler (key) {
			const member = this.members[key]
			this.form = {
				key: key,
				id: member.id,
				firstName: member.first_name,
				lastName: member.last_name,
				middleName: member.middle_name,
				email: member.email,
				phone: member.phone
			}
			this.toggleDialog()
		},
		addParticipantBtnHandler () {
			this.toggleDialog()
		},
		dialogClose (formName) {
			this.clearForm(formName)
			this.clearValidate(formName)
			this.dialogShow = false
		},
		clearForm (formName) {
			this.$refs[formName].resetFields()
			this.form = {}
			// this.form.firstName = ''
			// this.form.lastName = ''
			// this.form.middleName = ''
		},
		clearValidate (formName) {
			this.$refs[formName].clearValidate()
		},
		formSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let data = this.form
					if (data.id > 0) {
						apiMember.update(data.id, data).then((result) => {
							if (this.form.key >= 0) {
								this.members[this.form.key] = result
							}
							this.dialogClose(formName)
						})
					} else {
						apiMember.create(this.id, data).then((result) => {
							this.members.push(result)
							console.log(this.members)
							this.dialogClose(formName)
						})
					}
					this.clearValidate(formName)
				} else {
					console.log('Ошибка отправки! Бегом к йтишникам!')
					return false
				}
			})
		},
		deleteHandler (form) {
			this.$confirm('Вы действительно хотите удалить участника?', 'Внимание!', {
				confirmButtonText: 'Да',
				cancelButtonText: 'Отмена',
				type: 'warning'
			}).then(() => {
				let data = this.form
				apiMember.delete(data.id).then((result) => {
					if (this.form.key >= 0) {
						this.members.splice(this.form.key, 1)
					}
					this.dialogClose(form)
				})
			}).catch(() => {})
		},
		toggleDialog () {
			this.dialogShow = !this.dialogShow
		}
	}
}
</script>
<style lang="sass">
.payment-members
	margin-top: 15px
	.payment-members-item
		margin-bottom: 15px
.payment-members-itenm__body
	ul
		padding: 0
		margin: 0
		list-style: none
		li
			margin-top: 10px
			.icon
				margin-right: 10px
</style>



// WEBPACK FOOTER //
// src/components/payment/update/reservation.vue